import { HomeOutlined } from "@ant-design/icons";
import { SchoolContentItem } from "@axl-dev/school-sdk";
import { useMemo } from "react";

import { Breadcrumb } from "@app/shared/ui";

type Props = {
  folder: SchoolContentItem | null;
  onSelect: (item: SchoolContentItem | null) => void;
};
const SchoolContentBreadcrumb: React.FC<Props> = ({ folder, onSelect }) => {
  const items = useMemo(() => {
    if (!folder) return [];
    const nestedFolders = [folder];
    let p = folder.parent;
    while (p) {
      nestedFolders.push(p);
      p = p.parent;
    }

    return nestedFolders.reverse();
  }, [folder]);

  if (items.length === 0) return null;

  return (
    <Breadcrumb className="mb-20 fs-20">
      <Breadcrumb.Item key="root" onClick={() => onSelect(null)}>
        <HomeOutlined style={{ fontSize: "20px" }} />
      </Breadcrumb.Item>
      {items.map((x) => (
        <Breadcrumb.Item key={x.id} onClick={() => onSelect(x)}>
          {x.title}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default SchoolContentBreadcrumb;
